function ScrollTo(target) {
    document.querySelector(target).scrollIntoView({
        behavior: 'smooth',
    });
}

export default ScrollTo;
